import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { PETS } from '../constants';
import { PET_TYPES } from '../constants/stringConstants';
import { Section } from './';

class PetSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: PETS.FIELD_NAME.PET_IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: PETS.FIELD_NAME.TYPE,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: ValidationType.AlphaOnlyValidator,
      }),

      /* Conditional Fields */
      new Field({
        fieldName: PETS.FIELD_NAME.GENDER,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: ValidationType.AlphaOnlyValidator,
      }),
      new Field({
        fieldName: PETS.FIELD_NAME.BREED,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),

      new Field({
        fieldName: PETS.FIELD_NAME.LICENSE_NUMBER,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: PETS.FIELD_NAME.NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: PETS.FIELD_NAME.WEIGHT,
        enteredValue: '',
        dataType: FieldDataType.number,
        validation: ValidationType.PositiveIntegerValidator,
      }),
    ]);

    if (this.getTotalIndexes() === 0) {
      this.addOneIndex();
    }
  }

  static isDogType = (petType: string) => {
    const petTypeLowerCase = (petType || '').toLowerCase();
    return petTypeLowerCase === PET_TYPES.DOG.toLowerCase();
  };

  static isCatType = (petType: string) => {
    const petTypeLowerCase = (petType || '').toLowerCase();
    return petTypeLowerCase === PET_TYPES.CAT.toLowerCase();
  };

  static isOtherType = (petType: string) => {
    const petTypeLowerCase = (petType || '').toLowerCase();
    return (
      petType != null &&
      petTypeLowerCase !== PET_TYPES.CAT.toLowerCase() &&
      petTypeLowerCase !== PET_TYPES.DOG.toLowerCase()
    );
  };
}

export default PetSection;
